<template>
  <!-- 根据角色获取列表 -->
  <el-menu
    :router="true"
    :unique-opened="true"
    :default-active="path"
    class="el-menu-vertical-demo"
    @select="handleOpen"
  >
    <label v-for="item in rightList" :key="item.id">
      <el-menu-item
        class="menu-first-link"
        v-if="item.children.length == 0"
        slot="title"
        :index="String(item.path)"
      >
      <i :class="item.navtabid"></i>
        <router-link style="display:inline-block;height:100%;" :to="item.path">{{item.name}}</router-link>
      </el-menu-item>

      <el-submenu v-if="item.children.length != 0" :index="String(item.path)">
        <template slot="title">
          <span class="menu-first-link">{{item.name}}</span>
        </template>

        <el-menu-item v-for="item2 in item.children" :key="item2.id" :index="item2.path">
          <router-link class="menu-second-link" :to="item2.path">{{item2.name}}</router-link>
        </el-menu-item>
      </el-submenu>
    </label>
  </el-menu>
</template>

<script>
export default {
  data: function() {
    return {
      //   rightList: [
      //     {
      //       id: 1,
      //       name: "上传",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:18:27",
      //       orderno: 1,
      //       path: "/news/one",
      //       children: [
      //         {
      //           id: 1001,
      //           name: "新建新闻图片",
      //           parentId: 1,
      //           menuType: 1,
      //           menuState: 0,
      //           createUserid: null,
      //           createTime: null,
      //           orderno: 1,
      //           path: "/news/one/1",
      //           children: null
      //         },
      //         {
      //           id: 1002,
      //           name: "新建创意图片",
      //           parentId: 1,
      //           menuType: 1,
      //           menuState: 0,
      //           createUserid: null,
      //           createTime: null,
      //           orderno: 2,
      //           path: "/news/one/4b58505286f64aca95d45574ba467ffc",
      //           children: null
      //         }
      //       ]
      //     },
      //     {
      //       id: 4,
      //       name: "草稿箱",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:21:24",
      //       orderno: 2,
      //       path: "/mydraft",
      //       children: []
      //     },
      //     {
      //       id: 5,
      //       name: "我的图片",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:22:24",
      //       orderno: 3,
      //       path: "/mypic",
      //       children: []
      //     },
      //     {
      //       id: 6,
      //       name: "作品下载记录",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:23:06",
      //       orderno: 4,
      //       path: "/record",
      //       children: []
      //     },
      //     {
      //       id: 8,
      //       name: "收藏夹",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:32:35",
      //       orderno: 99,
      //       path: "/favorite",
      //       children: []
      //     },
      //     {
      //       id: 9,
      //       name: "个人设置",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:32:35",
      //       orderno: 100,
      //       path: "/base",
      //       children: []
      //     },
      //     {
      //       id: 7,
      //       name: "积分记录",
      //       parentId: 0,
      //       menuType: 1,
      //       menuState: 0,
      //       createUserid: "1",
      //       createTime: "2019-07-26 15:32:35",
      //       orderno: 5,
      //       path: "/integralrecode",
      //       children: []
      //     }
      //   ]
      rightList: [
        // {
        //   id: 0,
        //   path: "/personalcenter/personalinfo",
        //   name: "个人信息",
        //   children: []
        // },
        // {
        //   id: 1,
        //   name: "修改密码",
        //   path: "/personalcenter/changepwd",
        //   children: []
        // },
        // {
        //   id: 2,
        //   name: "收藏夹",
        //   path: "/personalcenter/favorite",
        //   children: []
        // },
        // {
        //   id: 3,
        //   name: "后台管理",
        //   path: "/adminstrator",
        //   children: []
        // }
      ]
    };
  },
  methods: {
    handleOpen: function() {
      // console.log("aaaa");
    },
    getRightList: async function() {
      var res = await this.$http.get("/v1/role/qtlist");
      var { code, message, data } = res.data;
      if (code == 0) {
        this.rightList = data;
      }
    }
  },
  computed: {
    path: function() {
      // 得到当前路由
      return this.$route.path;
    }
  },
  mounted: function() {
    this.getRightList();
  }
};
</script>

<style scoped lang="scss">
/* 侧边栏样式 */
a {
  text-decoration: none;
  color: black;
}
.el-menu{
  border-right: none;
}
.el-submenu {
  border-bottom: 1px solid #f8f8f8;
}
.menu-first-link {
  font-size: 16px;
  font-weight: 400;
  color: black;
  border-bottom: 1px solid #f8f8f8;
}
.menu-second-link {
  display: block;
  width: 100%;
  height: 100%;
  color: #787878;
}
.el-menu-item.is-active {
  // border-left: 3px solid #f56c6c;
  border-right: 2px solid #00aaff;
  background-color: #e5f6ff;
  color: #409eff;
  a {
    color: #409eff;
  }
}
.el-menu-item:hover {
  background-color: #e5f6ff;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar.vue